import { useQuery } from '@tanstack/react-query'
import { getAllMaterials } from 'service/materials'

export const MATERIALS_DB_NAME = 'materials'

export const useGetMaterials = () => {
  const query = useQuery(
    ['fetchMaterials'],
    async () => {
      return {
        materials: await getAllMaterials()
      }
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      refetchOnMount: false
    }
  )

  return { materials: query.data?.materials ?? [], query }
}
